<template>
	<div class="checkout wrapper murk">
		<!-- empty page that verify token only spinner show in the page -->
	</div>
</template>

<script>
import config from '../config/environment-config';

export default {
	name: 'CodeRedeem',
	orderNumber: 'reviewPurchase',

	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('code-redeem.title')}`,
		};
	},
	computed: {
		gameName() {
			return this.$route.params.gameName;
		},
		returnURL() {
			return this.$route.query.return_url;
		},
	},
	mounted() {
		const mainSpinner = document.getElementById('main-spinner');
		this.$cookie.set(
			'codeRedeemRetry',
			`${config[process.env.VUE_APP_ENV][environment.region].checkout}/code-redeem/${this.gameName}?return_url=${
				this.returnURL
			}`
		);

		if (mainSpinner.classList.contains('hide')) {
			mainSpinner.classList.remove('hide');
		}

		this.$http
			.get(
				`${config[process.env.VUE_APP_ENV][environment.region].API}${currentApiVersion}/coupon/games/${
					this.gameName
				}?return_url=${this.returnURL}&language=${this.locale}`
			)
			.then((response) => {
				this.redeemAnotherUrl = response.data.URL;
				this.goto(this.redeemAnotherUrl);
			})
			.catch((error) => {
				console.log(error.response.data);
			});
	},
};
</script>
